export const environment = {
  production: false,
  config: {
    api: '',
  },
  version: '2.5.8-SNAPSHOT.3449',
};
